export default __webpack_public_path__ + "static/media/wallet_freighter.c4ac078f.svg";